import React, { useState, useEffect } from "react";
import axios from "../../../../utils/apidsf";
import RichTextEditor from "react-rte";
import swal from "sweetalert";

import useUpload from "../../../../hooks/UseUpload";
// components
import FormField from "../../Components/FormField/FormField";
import { Button } from "@mui/material";
import "./style.css";
export default function CreateArticle() {
  const { upload } = useUpload();
  const [pdf, setPdf] = useState("");
  // const [filetoken, setfiletoken] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    expiredate: "",
    description: "",
    pdf: "",
    RechtextforDescription: RichTextEditor.createEmptyValue(),
    RechTextForPdfDescription: RichTextEditor.createEmptyValue(),
    pdfDescription: "",
    category: "inapp",
  });

  const onChange = (value) => {
    let data = value.toString("html");

    setFormData({
      ...formData,
      description: data,
      RechtextforDescription: value,
    });
  };
  const handleInputChange = (e) => {
    // setFormData
    console.log(e.target.name);
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  //   console.log(formData.paper);
  const handelsubmit = async (e) => {
    try {
      const respones = await upload(pdf);
      formData.pdf = respones.data.source_url;
      console.log(respones);
      swal({
        title: "Success",
        text: "Pdf Uploaded",
        icon: "success",
      });
    } catch (err) {
      console.log(err);
      console.log(err.response.data);
      console.log(err.response.status);

      swal({
        title: "Error",
        text: err.response.data.error,
        icon: "error",
      });
      return;
    }

    let token = JSON.parse(localStorage.getItem("token"));
    console.log(formData);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    axios
      .post(
        "/admin/notification",
        {
          category: formData.category,
          description: formData.description,
          expiredate: formData.expiredate,
          title: formData.title,
          pdf: formData.pdf,
          pdfDescription: formData.pdfDescription,
        },
        config
      )
      .then((e) => {
        console.log(e.data.success);
        if (e.data.success) {
          swal("Success!", "Notification added Sucessfully!", "success");
        }
      });
  };

  const category = ["inapp", "exam"];
  return (
    <div style={{ flex: 4 }}>
      <form action="" className="admin__userUpdateForm" onSubmit={handelsubmit}>
        <div className="userUpdateItem">
          <h3 className="user__label">Add new Notification</h3>
          <FormField
            type="text"
            label="Title"
            className="title"
            placeholder="Title"
            value={formData.title}
            name="title"
            handleChange={handleInputChange}
          />
          <RichTextEditor
            className="desc_area"
            value={formData?.RechtextforDescription}
            onChange={onChange}
          />
          <div className="userUpdateItem">
            <label className="user__label">Date</label>
            <input
              type="datetime-local"
              placeholder="Date"
              className="userUpdateInput"
              value={formData.date}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  expiredate: e.target.value,
                });
              }}
            />
          </div>
          <label className="user__label">Category</label>
          <select
            value={formData.category}
            onChange={(e) => {
              console.log(e.target.value);
              setFormData({
                ...formData,
                category: e.target.value,
              });
            }}
          >
            {category.map((w, i) => {
              return (
                <option value={w} key={i}>
                  {w}
                </option>
              );
            })}
          </select>

          <RichTextEditor
            className="desc_area pdfDesc"
            value={formData?.RechTextForPdfDescription}
            onChange={(value) => {
              let data = value.toString("html");
              console.log({ formData });
              setFormData({
                ...formData,
                RechTextForPdfDescription: value,
                pdfDescription: data,
              });
            }}
          />
          <div className="Notification_pdfInput">
            <label htmlFor="fileInput">Select Pdf</label>
            <input
              type="file"
              name="fileInput"
              accept={"application/pdf"}
              onChange={(e) => {
                setPdf(e.target.files[0]);
              }}
            />
          </div>

          <Button
            className="create_user_btn"
            variant="contained"
            style={{ margin: "20px" }}
            onClick={(e) => handelsubmit(e)}
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}
